import common from '@/store/common/mutations';
import * as types from './mutation-types';
export default {
	...common,
	[types.STATE_INIT]: state => {
		state.claimInfo = [];
		state.partCkuScrId = '';
		state.pwaApcnScrId = '';
		state.clamRepayScrId = '';
		state.roApcnListScrId = '';
		state.rtnPartMstScrId = '';
	},

	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		//console.log('key ::: ', key);
		//console.log('value ::: ', value);
		state[key] = value;
	},
	[types.CLAIM_INFO]: (state, { key, value }) => {
		state.claiminfo[key] = value;
	}
};
